module.exports = __webpack_public_path__ + "media/img/illustrations/danger-exclamation-f45e6083d93db07c7ae5c8069ad3537e.svg";